import { render } from "./SelectedFilters.vue?vue&type=template&id=0f7d70f1&scoped=true&ts=true"
import script from "./SelectedFilters.ts?vue&type=script&lang=ts&external"
export * from "./SelectedFilters.ts?vue&type=script&lang=ts&external"

import "./SelectedFilters.scss?vue&type=style&index=0&id=0f7d70f1&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7d70f1"]])

export default __exports__